import axiosInstance from './axiosInstance';

/**
 * 제작사 프로필 생성 (온보딩)
 * @param {{ companyName, managerName, phone, contactEmail, website, address, businessRegNumber }} data
 * @returns {{ id: number }}
 */
export const createProducerProfile = async (data) => {
  const res = await axiosInstance.post('/api/producer/onboarding', data);
  return res.data;
};

/**
 * 내 제작사 프로필 조회 (로그인 사용자 본인)
 * @returns ProducerProfileResDto (id 포함)
 */
export const getMyProducerProfile = async () => {
  const res = await axiosInstance.get('/api/producer/me');
  return res.data;
};

/**
 * 제작사 프로필 수정
 * @param {{ id, companyName, managerName, phone, contactEmail, website,
 *           address, businessRegNumber, logoFileId }} data
 */
export const updateProducerProfile = async (data) => {
  const res = await axiosInstance.put('/api/producer', data);
  return res.data;
};

/**
 * 제작사 로고 삭제
 * 백엔드 미구현 환경에서는 404/405가 날 수 있으므로 호출부에서 fallback 처리
 */
export const deleteProducerLogo = async () => {
  const res = await axiosInstance.delete('/api/producer/logo');
  return res.data;
};

/* ── 제작 작품 ── */

/**
 * 내 제작 작품 목록
 * @returns Array<{ id, title, genre, year, platform }>
 */
export const getProducerWorks = async () => {
  const res = await axiosInstance.get('/api/producer/works');
  return Array.isArray(res.data) ? res.data : (res.data?.content ?? []);
};

/**
 * 제작 작품 추가
 * @param {{ title, genre, year, platform }} data
 * @returns {{ id: number }}
 */
export const createProducerWork = async (data) => {
  const res = await axiosInstance.post('/api/producer/works', data);
  return res.data;
};

/**
 * 제작 작품 수정
 * @param {number} id
 * @param {{ title, genre, year, platform }} data
 */
export const updateProducerWork = async (id, data) => {
  await axiosInstance.put(`/api/producer/works/${id}`, data);
};

/**
 * 제작 작품 삭제
 * @param {number} id
 */
export const deleteProducerWork = async (id) => {
  await axiosInstance.delete(`/api/producer/works/${id}`);
};

/* ── 리뷰 ── */

/**
 * 제작사 회사 소개 및 전문 분야 수정
 * @param {{ companyDescription: string, specialties: string[] }} data
 */
export const patchProducerCompanyProfile = async (data) => {
  const res = await axiosInstance.patch('/api/producer/profile', data);
  return res.data;
};

/**
 * 내 제작사에 달린 리뷰 목록
 * @returns Array<{ id, rating, comment, actorName, castingTitle, createdAt }>
 */
export const getProducerReviews = async () => {
  const res = await axiosInstance.get('/api/producer/reviews');
  return Array.isArray(res.data) ? res.data : (res.data?.content ?? []);
};

/**
 * 제작사 프로필 통계
 * @returns {{ viewCount, weeklyViewers, bookmarkCount, activePostingCount }}
 */
export const getProducerStats = async () => {
  const res = await axiosInstance.get('/api/producer/me/stats');
  return res.data;
};

/**
 * 제작사 프로필 조회 기록
 * @param {number} id - producerProfileId
 */
export const recordProducerVisit = async (id) => {
  await axiosInstance.post(`/api/producer/${id}/visit`);
};

/**
 * 특정 제작사 프로필 공개 조회
 * @param {number|string} id - producerProfileId
 * @returns ProducerProfileResDto
 */
export const getProducerById = async (id) => {
  const res = await axiosInstance.get(`/api/producer/${id}`);
  return res.data;
};
